import { render } from "./changePass.vue?vue&type=template&id=5e2d3a1f&scoped=true"
import script from "./changePass.vue?vue&type=script&lang=js"
export * from "./changePass.vue?vue&type=script&lang=js"

import "./changePass.vue?vue&type=style&index=0&id=5e2d3a1f&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2d3a1f"]])

export default __exports__